import { fetch } from '../../utils';
import Backend from '../../backend';

const ANALYZE_PATH = 'ai/analyze_projection';

/**
 * List illustration OCR results for the current user.
 */
export const getIllustrations = () => {
  return fetch(Backend.methodUrl('illustration-ocr'), {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' }
  })
    .then(res => res.json())
    .then(payload => payload)
    .catch(error => {
      throw error;
    });
};

/**
 * Upload a PDF/image for projection-table OCR.
 * @param {FormData} formData - feature, data (JSON string), pdf|image
 */
export const uploadProjection = formData => {
  return fetch(Backend.methodUrl(ANALYZE_PATH), {
    method: 'POST',
    body: formData
  })
    .then(res => res.json())
    .then(payload => payload)
    .catch(error => {
      throw error;
    });
};

/**
 * Poll for an in-flight projection analysis result.
 * @param {string} requestId
 */
export const pollProjection = requestId => {
  return fetch(Backend.methodUrl(ANALYZE_PATH), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ requestId })
  })
    .then(res => res.json())
    .then(payload => payload)
    .catch(error => {
      throw error;
    });
};

/**
 * Create (persist) an illustration OCR result — only on explicit user Save.
 * @param {object} payload - analyze poll response body
 */
export const createIllustration = payload => {
  return fetch(Backend.methodUrl('illustration-ocr'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload || {})
  })
    .then(res => res.json())
    .then(json => json)
    .catch(error => {
      throw error;
    });
};

/**
 * Update a persisted illustration OCR result (e.g. corrected projection values).
 * @param {string} id
 * @param {{ projection?: Array, meta?: Object }} payload
 */
export const updateIllustration = (id, payload) => {
  return fetch(Backend.methodUrl(`illustration-ocr/${id}`), {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload || {})
  })
    .then(res => res.json())
    .then(json => json)
    .catch(error => {
      throw error;
    });
};

/**
 * Delete illustration OCR results by ids.
 * @param {string[]} ids
 */
export const deleteIllustrations = ids => {
  return fetch(Backend.methodUrl('illustration-ocr'), {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ids: ids || [] })
  })
    .then(res => res.json())
    .then(json => json)
    .catch(error => {
      throw error;
    });
};

/**
 * Reverse-index a consumer record onto an illustration.
 * @param {string} id
 * @param {{ feature?: string, linkedId?: string }} payload
 */
export const linkIllustration = (id, { feature, linkedId } = {}) => {
  return fetch(Backend.methodUrl(`illustration-ocr/${id}/link`), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ feature, linkedId })
  })
    .then(res => res.json())
    .then(json => json)
    .catch(error => {
      throw error;
    });
};

/**
 * Remove a consumer id from illustrations.meta.linked[feature]. Does not clear feature_origin.
 * @param {string} id
 * @param {{ feature?: string, linkedId?: string }} payload
 */
export const unlinkIllustration = (id, { feature, linkedId } = {}) => {
  return fetch(Backend.methodUrl(`illustration-ocr/${id}/unlink`), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ feature, linkedId })
  })
    .then(res => res.json())
    .then(json => json)
    .catch(error => {
      throw error;
    });
};
